import toastr from 'toastr'
import layout from 'layouts/default'
import { user } from 'services'
import { hasPermits } from 'directives'
import { editableRadio, editableText, editableCheckbox } from 'components/editable'
import sSelect from 'components/sSelect'

const directives = {
    hasPermits
}

let components = {
    layout,
    editableRadio,
    editableText,
    editableCheckbox,
    sSelect
}

let methods = {
  onEditSetting (editableData, item) {
      if (item.type === 'list') {
        item.value = item.value.map(option => {
          if (option.key === editableData.target.value) {
            option.selected = 1;
          } else {
            option.selected = 0;
          }
          return option;
        });
      } else {
        item.value = editableData.value;
        editableData.startLoading();
      }

      this.$store.dispatch('settings.updateSetting', {
        id: item.id, data: item
      }).then(() => {
        if (item.type !== 'list') {
          editableData.stopLoading();
        }
        let errors;
        if (this.$store.state.settings.errors) {
          errors = this.$store.state.settings.errors;
          if (errors.errors) {
            _.forEach(errors.errors, (error) => {
              toastr.error(error[0]);
            })
          } else {
            toastr.error(errors.message);
          }
        } else {
          toastr.success('Setting updated successfully');
          if (item.type !== 'list') {
            editableData.close();
          }
        }
      })
  },

  formatKey(key) {
      if (!key) return '';
      return key.split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
  },
}

let computed = {
  
  settings() {
    return _.cloneDeep(this.$store.state.settings.all).map((setting) => {
      if (setting.type !== 'list') return setting;

      if (Array.isArray(setting.value)) return setting;

      if (typeof setting.value === 'string') {
        try {
          const parsed = JSON.parse(setting.value);
          setting.value = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          setting.value = [];
        }
      } else {
        setting.value = [];
      }

      return setting;
    });
  },

  groups() {
    const all = this.settings
      .map(s => s.group)
      .filter(g => g != null && g !== '');
    return _.uniq(all).sort();
  },

  filteredSettings() {
    if (!this.selectedGroup) return this.settings;
    return this.settings.filter(s => s.group === this.selectedGroup);
  },
}

export default {
    name: "settings",
    directives,
    methods,
    components,
    computed,
    data() {
        return {
            errors: {},
            form: null,
            processing: true,
            selectedGroup: null,
        }
    },
    created() {
        this.$store.dispatch('settings.getAllSettings').then(() => {
            this.processing = false;
        });
    },
    mounted() {
    }
}